import { NavigationSubItem } from "../navigation-item"

export class VotingLockSubItem extends NavigationSubItem {
  readonly id = "voting"
  readonly label = "Vote"
  readonly href = "/vote"
  readonly iconName = "vote-icon"
  readonly isExternal = false
  readonly tabs = []
}
